import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0899b593"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "details-tab flexcenter" }
const _hoisted_2 = { class: "contentBox" }
const _hoisted_3 = {
  key: 0,
  class: "ouBox"
}
const _hoisted_4 = { class: "titleRow" }
const _hoisted_5 = { style: {"width":"43%"} }
const _hoisted_6 = { style: {"width":"18%","text-align":"center"} }
const _hoisted_7 = { style: {"width":"18%","text-align":"center"} }
const _hoisted_8 = { style: {"width":"18%","text-align":"center"} }
const _hoisted_9 = { style: {"width":"23%","text-align":"right"} }
const _hoisted_10 = { style: {"margin-top":"10px"} }
const _hoisted_11 = { class: "titleRow" }
const _hoisted_12 = { style: {"width":"22%","color":"#0D0D0D","font-size":"13px"} }
const _hoisted_13 = {
  class: "cz",
  style: {"width":"21%"}
}
const _hoisted_14 = { style: {"width":"18%","text-align":"center","font-size":"13px"} }
const _hoisted_15 = { style: {"color":"#0D0D0D"} }
const _hoisted_16 = { class: "top" }
const _hoisted_17 = { style: {"width":"18%","text-align":"center","font-size":"13px"} }
const _hoisted_18 = { style: {"color":"#0D0D0D"} }
const _hoisted_19 = { class: "top" }
const _hoisted_20 = { style: {"width":"18%","text-align":"center","font-size":"13px"} }
const _hoisted_21 = { style: {"color":"#0D0D0D"} }
const _hoisted_22 = { class: "top" }
const _hoisted_23 = { style: {"width":"23%","text-align":"right","font-size":"13px"} }
const _hoisted_24 = { style: {"color":"#0D0D0D"} }
const _hoisted_25 = { class: "top" }
const _hoisted_26 = {
  key: 1,
  class: "rqBox"
}
const _hoisted_27 = { class: "titleRow" }
const _hoisted_28 = { class: "box" }
const _hoisted_29 = { style: {"margin-left":"10px"} }
const _hoisted_30 = {
  class: "num",
  style: {"color":"#FC2E34"}
}
const _hoisted_31 = {
  class: "num",
  style: {"color":"#7CDF6A"}
}
const _hoisted_32 = { class: "box flexright" }
const _hoisted_33 = {
  class: "num",
  style: {"color":"#FC2E34"}
}
const _hoisted_34 = {
  class: "num",
  style: {"margin-right":"10px","color":"#7CDF6A"}
}
const _hoisted_35 = { class: "huiRow" }
const _hoisted_36 = { style: {"width":"24%"} }
const _hoisted_37 = { style: {"width":"38%"} }
const _hoisted_38 = { style: {"width":"38%"} }
const _hoisted_39 = { class: "listDiv" }
const _hoisted_40 = { class: "itemDiv" }
const _hoisted_41 = { style: {"width":"24%"} }
const _hoisted_42 = { style: {"width":"38%"} }
const _hoisted_43 = { style: {"color":"#878787","margin":"0 10px"} }
const _hoisted_44 = { style: {"width":"38%","border-right":"0"} }
const _hoisted_45 = { style: {"color":"#878787","margin":"0 10px"} }
const _hoisted_46 = {
  key: 2,
  class: "rqBox"
}
const _hoisted_47 = { class: "titleRow" }
const _hoisted_48 = { class: "box" }
const _hoisted_49 = { style: {"margin-left":"10px"} }
const _hoisted_50 = {
  class: "num",
  style: {"color":"#FC2E34"}
}
const _hoisted_51 = {
  class: "num",
  style: {"color":"#7CDF6A"}
}
const _hoisted_52 = { class: "box flexright" }
const _hoisted_53 = {
  class: "num",
  style: {"color":"#FC2E34"}
}
const _hoisted_54 = {
  class: "num",
  style: {"margin-right":"10px","color":"#7CDF6A"}
}
const _hoisted_55 = { class: "huiRow" }
const _hoisted_56 = { style: {"width":"24%"} }
const _hoisted_57 = { style: {"width":"38%"} }
const _hoisted_58 = { style: {"width":"38%"} }
const _hoisted_59 = { class: "listDiv" }
const _hoisted_60 = { class: "itemDiv" }
const _hoisted_61 = { style: {"width":"24%"} }
const _hoisted_62 = { style: {"width":"38%"} }
const _hoisted_63 = { style: {"color":"#878787","margin":"0 10px"} }
const _hoisted_64 = { style: {"width":"38%","border-right":"0"} }
const _hoisted_65 = { style: {"color":"#878787","margin":"0 10px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_divider = _resolveComponent("van-divider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.selType = 0)),
          style: _normalizeStyle({
                color: $setup.selType == 0 ? '#fff' : $setup.primaryColor,
                'background-color': $setup.selType == 0 ? $setup.primaryColor : '#fff',
            })
        }, _toDisplayString(_ctx.$t('play.yz')), 5 /* TEXT, STYLE */),
        _createElementVNode("li", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.selType = 1)),
          style: _normalizeStyle({
                color: $setup.selType == 1 ? '#fff' : $setup.primaryColor,
                'background-color': $setup.selType == 1 ? $setup.primaryColor : '#fff',
            }),
          class: "cenli"
        }, _toDisplayString(_ctx.$t('play.rq')), 5 /* TEXT, STYLE */),
        _createElementVNode("li", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.selType = 2)),
          style: _normalizeStyle({
                color: $setup.selType == 2 ? '#fff' : $setup.primaryColor,
                'background-color': $setup.selType == 2 ? $setup.primaryColor : '#fff',
            })
        }, _toDisplayString(_ctx.$t('play.jqs')), 5 /* TEXT, STYLE */)
      ])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode(" 欧指 "),
      ($setup.selType == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('play.zlly')), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('play.win')), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('play.draw')), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('play.owe')), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('play.fhv')), 1 /* TEXT */)
            ]),
            ($setup.datas)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.datas, (item) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, _toDisplayString($setup.COMPANYNAME[item.company_id] ? $setup.COMPANYNAME[item.company_id] : ''), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", null, _toDisplayString($setup.t('me.chu')), 1 /* TEXT */),
                        _createElementVNode("div", null, _toDisplayString($setup.t('me.ji')), 1 /* TEXT */)
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("div", _hoisted_15, _toDisplayString($setup.getInitEu(item.initIdex, 0)), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_16, _toDisplayString($setup.getRealEu(item.realTime, 0)), 1 /* TEXT */)
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, _toDisplayString($setup.getInitEu(item.initIdex, 1)), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_19, _toDisplayString($setup.getRealEu(item.realTime, 1)), 1 /* TEXT */)
                      ]),
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, _toDisplayString($setup.getInitEu(item.initIdex, 2)), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_22, _toDisplayString($setup.getRealEu(item.realTime, 2)), 1 /* TEXT */)
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, _toDisplayString($setup.getResult(item.initIdex)), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_25, _toDisplayString($setup.getResult(item.realTime)), 1 /* TEXT */)
                      ])
                    ]),
                    _createVNode(_component_van_divider)
                  ]))
                }), 256 /* UNKEYED_FRAGMENT */))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" 让球 "),
      ($setup.selType == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.$t('me.sp')), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_30, _toDisplayString($setup.shengpan), 1 /* TEXT */),
                _createElementVNode("div", null, _toDisplayString(_ctx.$t('me.jp')), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_31, _toDisplayString($setup.jp), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", null, _toDisplayString(_ctx.$t('me.gs')), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_33, _toDisplayString($setup.gs), 1 /* TEXT */),
                _createElementVNode("div", null, _toDisplayString(_ctx.$t('me.ds')), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_34, _toDisplayString($setup.ds), 1 /* TEXT */)
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t('me.pkly')), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t('me.cspk')), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.$t('me.jspk')), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_39, [
              ($setup.datas)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.datas, (item) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, _toDisplayString($setup.COMPANYNAME[item.company_id] ? $setup.COMPANYNAME[item.company_id] : ''), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_42, [
                        _createElementVNode("span", null, _toDisplayString($setup.getasia(0, item.initIdex)), 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_43, _toDisplayString($setup.getasia(1, item.initIdex)), 1 /* TEXT */),
                        _createElementVNode("span", null, _toDisplayString($setup.getasia(2, item.initIdex)), 1 /* TEXT */)
                      ]),
                      _createElementVNode("div", _hoisted_44, [
                        _createElementVNode("span", null, _toDisplayString($setup.getasia(0, item.realTime)), 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_45, _toDisplayString($setup.getasia(1, item.realTime)), 1 /* TEXT */),
                        _createElementVNode("span", null, _toDisplayString($setup.getasia(2, item.realTime)), 1 /* TEXT */)
                      ])
                    ]))
                  }), 256 /* UNKEYED_FRAGMENT */))
                : _createCommentVNode("v-if", true)
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" 进球数 "),
      ($setup.selType == 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.$t('me.sp')), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_50, _toDisplayString($setup.shengpan2), 1 /* TEXT */),
                _createElementVNode("div", null, _toDisplayString(_ctx.$t('me.jp')), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_51, _toDisplayString($setup.jp2), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("div", null, _toDisplayString(_ctx.$t('me.jp')), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_53, _toDisplayString($setup.gs2), 1 /* TEXT */),
                _createElementVNode("div", null, _toDisplayString(_ctx.$t('me.ds')), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_54, _toDisplayString($setup.ds2), 1 /* TEXT */)
              ])
            ]),
            _createElementVNode("div", _hoisted_55, [
              _createElementVNode("div", _hoisted_56, _toDisplayString(_ctx.$t('me.pkly')), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_57, _toDisplayString(_ctx.$t('me.cspk')), 1 /* TEXT */),
              _createElementVNode("div", _hoisted_58, _toDisplayString(_ctx.$t('me.jspk')), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_59, [
              ($setup.datas)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.datas, (item) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_60, [
                      _createElementVNode("div", _hoisted_61, _toDisplayString($setup.COMPANYNAME[item.company_id] ? $setup.COMPANYNAME[item.company_id] : ''), 1 /* TEXT */),
                      _createElementVNode("div", _hoisted_62, [
                        _createElementVNode("span", null, _toDisplayString($setup.getbs(0, item.initIdex)), 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_63, _toDisplayString($setup.getbs(1, item.initIdex)), 1 /* TEXT */),
                        _createElementVNode("span", null, _toDisplayString($setup.getbs(2, item.initIdex)), 1 /* TEXT */)
                      ]),
                      _createElementVNode("div", _hoisted_64, [
                        _createElementVNode("span", null, _toDisplayString($setup.getbs(0, item.realTime)), 1 /* TEXT */),
                        _createElementVNode("span", _hoisted_65, _toDisplayString($setup.getbs(1, item.realTime)), 1 /* TEXT */),
                        _createElementVNode("span", null, _toDisplayString($setup.getbs(2, item.realTime)), 1 /* TEXT */)
                      ])
                    ]))
                  }), 256 /* UNKEYED_FRAGMENT */))
                : _createCommentVNode("v-if", true)
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}